import { render, staticRenderFns } from "./ViberIncomingTariff.vue?vue&type=template&id=25319b62&"
import script from "./ViberIncomingTariff.vue?vue&type=script&lang=ts&"
export * from "./ViberIncomingTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports